var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.8926C6.477 21.8926 2 17.4156 2 11.8926C2 6.37058 6.477 1.89258 12 1.89258C17.523 1.89258 22 6.37058 22 11.8926C22 17.4156 17.523 21.8926 12 21.8926ZM12 6.89258C11.7348 6.89258 11.4804 6.99793 11.2929 7.18547C11.1054 7.37301 11 7.62736 11 7.89258V12.8926C11 13.1578 11.1054 13.4121 11.2929 13.5997C11.4804 13.7872 11.7348 13.8926 12 13.8926C12.2652 13.8926 12.5196 13.7872 12.7071 13.5997C12.8946 13.4121 13 13.1578 13 12.8926V7.89258C13 7.62736 12.8946 7.37301 12.7071 7.18547C12.5196 6.99793 12.2652 6.89258 12 6.89258ZM12 16.8926C12.2652 16.8926 12.5196 16.7872 12.7071 16.5997C12.8946 16.4121 13 16.1578 13 15.8926C13 15.6274 12.8946 15.373 12.7071 15.1855C12.5196 14.9979 12.2652 14.8926 12 14.8926C11.7348 14.8926 11.4804 14.9979 11.2929 15.1855C11.1054 15.373 11 15.6274 11 15.8926C11 16.1578 11.1054 16.4121 11.2929 16.5997C11.4804 16.7872 11.7348 16.8926 12 16.8926Z",
    fill: "#FF9C00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.7716e63397168ecd685db66785ccfc66.svg";
export { ForwardRef as ReactComponent };